import { timeAgo } from "../TimeAgo";
import { activityIcons, getActivityContent } from "./recentActivityHelpers";

const RecentActivityRow = ({ activity,  isLast }) => {
  const content = getActivityContent(activity);

  if(activity.activityType == "GUARDIAN_APPROVAL_COMPLETED")
  {
    //console.log("Activity is: ");
    //console.log(activity);
  }

  return (
    <>
    <div
        key={activity._id}
        className={`flex max-xs:flex-col xs:items-center justify-between gap-3 px-4 py-4 md:px-5 ${
            isLast ? "" : "border-b border-stroked"
        }`}
    >

        <div className="flex items-center gap-3">

        <div className="flex-none size-10 bg-[#F7F7F5] rounded-14 flex justify-center items-center">

            <img
            src={
                activityIcons[activity.activityType]
            }
            alt=""
            className="w-5 h-5"
            />

        </div>

        <p className="text-foreground font-normal text-sm md:text-base">
            {content.text}
        </p>

        </div>

        <span className="flex-none text-foreground font-normal text-sm">
        {timeAgo(activity.occurredAt)}
        </span>

    </div>

    </>
  );
};

export default RecentActivityRow;